'use strict';

var _ = require('lodash');

var Advertise = require('../items/advertise.jsx');


var AdvertiseStore = function() {
    this._positions = [
        'banner_rm2',
        'banner_rm3'
    ];
};

AdvertiseStore.prototype = {
    'name': 'AdvertiseStore',
    _espPubPosition: 'banner_feed_esppub',
    _usedHashes: [],

    pick: function(info) {
        var position;

        if (info.fromFirstPage) {
            position = this._positions.shift();
            this._positions.push(position);

            return this.makeAdvertise(position);
        }
    },

    pickSpecialAd: function(info) {
        if (info.fromFirstPage) {
            return this.makeAdvertise(this._espPubPosition);
        }
    },

    makeAdvertise: function(name) {
        return {
            name: name,
            hash: this.generateHash(),
            klass: Advertise
        };
    },

    generateHash: function() {
        var hash = Math.random().toString().replace('.', '');

        if (_.includes(this._usedHashes, hash)) {
            hash = this.generateHash();
        }

        return hash;
    }
};

module.exports = AdvertiseStore;
